import { UI, VStack } from '@genial/components';
import React from 'react';

export interface AssetTitleWithSubtitleProps {
  title: string;
  subtitle: string;
}

export const AssetTitleWithSubtitle: React.FC<AssetTitleWithSubtitleProps> = ({
  title,
  subtitle,
}) => {
  return (
    <UI.Tooltip label={title || ''}>
      <VStack>
        <UI.Text variant="semibold" color="neutral.darkest" noOfLines={1}>
          {title}
        </UI.Text>

        <UI.Text color="neutral.dark">{subtitle}</UI.Text>
      </VStack>
    </UI.Tooltip>
  );
};
